import React from 'react';
import { Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import BaseErrorFallback from './BaseErrorFallback.jsx';

const BaseRoute = (children, path = undefined, index = undefined) => (
    <Route
        {...(path && { path })}
        {...(index && { index })}
        element={
            <ErrorBoundary FallbackComponent={(props) => BaseErrorFallback({ ...props })}>{children}</ErrorBoundary>
        }
    />
);

export default BaseRoute;
